// --- Our Modules --------------------------------------------------------------------------------
import type { TyCategory } from "@/types";
import useTranslation from "@/hooks/useTranslation";
import "./styles.css";

// --- Types --------------------------------------------------------------------------------------

type Props = {
    category: TyCategory;
    onPress?: () => void;
    onMore?: (e: React.MouseEvent<HTMLButtonElement>) => void;
    overrideCount?: number;
};

// --- Logic --------------------------------------------------------------------------------------

export default function CategoryCard({ category, onPress, onMore, overrideCount }: Props) {
    const t = useTranslation();

    return (
        <div className="category-card" onClick={onPress} style={onPress ? { cursor: "pointer" } : undefined}>
            <div className="category-card-info">
                <div className="category-card-icon-box">
                    <img src="/icons/category-icon.svg" alt="" width={24} height={24} />
                </div>
                <p className="category-card-name">{category.name}</p>
            </div>
            <div className="category-card-actions">
                {overrideCount !== undefined && overrideCount > 0 && (
                    <div className="category-card-override-badge">
                        <span>
                            {overrideCount} {t.branchMenu.changedCountLabel}
                        </span>
                    </div>
                )}
                <div className="category-card-count-badge">
                    <span>
                        {category.productsCount} {t.menu.productCount}
                    </span>
                </div>
                {onMore && (
                    <button
                        type="button"
                        className="category-card-more-btn"
                        onClick={(e) => {
                            e.stopPropagation();
                            onMore(e);
                        }}
                    >
                        <img src="/icons/more-icon.svg" alt="" width={16} height={16} />
                    </button>
                )}
            </div>
        </div>
    );
}
